import { faFrown, faMeh, faSmile, faTimesCircle, faCheckCircle } from "@fortawesome/pro-regular-svg-icons/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { useHostValue } from "../Contexts/HostContext";
import { GoogleEvent, sendGtmEvent } from "../GoogleTagManager";
import { ChatStates } from "../Interfaces/Stores/IHostStore";
import * as Action from "../Types/ReducerTypes";
import axios from 'axios';
function Survey() {
  var _a = useHostValue(),
    state = _a[0],
    dispatchChat = _a[1];
  var _b = useState('first'),
    step = _b[0],
    setStep = _b[1];
  var _c = useState(null),
    quality = _c[0],
    setQuality = _c[1];
  var _d = useState(''),
    message = _d[0],
    setMessage = _d[1];
  var timeOut;
  if (state.chat.running !== ChatStates.SURVEY) {
    return null;
  }
  function postResult(currentQuality) {
    return axios.post('/rest/survey', {
      hostId: state.chat.userId,
      chatId: state.chat.chatId,
      userAgent: navigator.userAgent,
      quality: currentQuality,
      message: message,
      client: state.chat.client
    });
  }
  function canceled() {
    if (quality !== null) {
      postResult(quality);
      sendGtmEvent(GoogleEvent.SURVEY_SOFT_SUBMITTED);
    } else {
      sendGtmEvent(GoogleEvent.SURVEY_CANCELED);
    }
    reset();
  }
  function submitted() {
    sendGtmEvent(GoogleEvent.SURVEY_SUBMITTED);
    postResult(quality).then(function () {
      setStep('thanks');
    });
  }
  function reset() {
    clearTimeout(timeOut);
    setStep('first');
    setQuality(null);
    setMessage('');
    dispatchChat({
      type: Action.SURVEY_END,
      running: ChatStates.NO
    });
  }
  function updateText(evt) {
    var newText = evt.target.value;
    if (newText.length < 301) {
      setMessage(newText);
    }
  }
  function handleClick(value) {
    setQuality(value);
    if (value < 3) {
      setStep('second');
    } else {
      sendGtmEvent(GoogleEvent.SURVEY_SUBMITTED);
      postResult(value);
      setStep('thanks');
    }
  }
  if (step === 'first') {
    return /*#__PURE__*/React.createElement("div", {
      id: 'surveyBlock'
    }, /*#__PURE__*/React.createElement("div", {
      id: 'survey'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'closer',
      onClick: canceled
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimesCircle
    })), /*#__PURE__*/React.createElement("h1", null, "Wie hat dir der Chat gefallen? ", /*#__PURE__*/React.createElement("small", null, "(optional)")), /*#__PURE__*/React.createElement("p", {
      className: 'smileyHolder'
    }, /*#__PURE__*/React.createElement("span", {
      onClick: function () {
        return handleClick(1);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faFrown
    }), /*#__PURE__*/React.createElement("br", null), "Schlecht"), /*#__PURE__*/React.createElement("span", {
      onClick: function () {
        return handleClick(2);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faMeh
    }), /*#__PURE__*/React.createElement("br", null), "Geht so"), /*#__PURE__*/React.createElement("span", {
      onClick: function () {
        return handleClick(3);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSmile
    }), /*#__PURE__*/React.createElement("br", null), "sehr gut"))));
  }
  if (step === 'second') {
    return /*#__PURE__*/React.createElement("div", {
      id: 'surveyBlock'
    }, /*#__PURE__*/React.createElement("div", {
      id: 'survey'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'closer',
      onClick: canceled
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimesCircle
    })), /*#__PURE__*/React.createElement("h1", null, "Deine Meinung ist uns wichtig"), /*#__PURE__*/React.createElement("p", null, "Was hat dir gefallen, oder was k\u00F6nnen wir noch besser machen? Sag uns deine Meinung ", /*#__PURE__*/React.createElement("small", null, "(optional)")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("textarea", {
      value: message,
      onChange: updateText
    }), /*#__PURE__*/React.createElement("small", {
      style: {
        float: 'right'
      }
    }, message.length, "/300")), /*#__PURE__*/React.createElement("input", {
      type: "button",
      className: 'submit',
      value: "Abschicken",
      onClick: submitted
    }), /*#__PURE__*/React.createElement("input", {
      type: "button",
      className: 'cancel',
      value: "Abbrechen",
      onClick: canceled
    })));
  }
  if (step === 'thanks') {
    if (typeof timeOut !== "undefined") {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(reset, 5000);
    return /*#__PURE__*/React.createElement("div", {
      id: 'surveyBlock',
      onClick: reset
    }, /*#__PURE__*/React.createElement("div", {
      id: 'survey'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'closer',
      onClick: reset
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimesCircle
    })), /*#__PURE__*/React.createElement("h1", null, "Deine Bewertung wurde erfolgreich \u00FCbermittelt"), quality < 3 && /*#__PURE__*/React.createElement("p", null, "Wir arbeiten stets daran uns zu verbessern"), /*#__PURE__*/React.createElement("p", {
      className: 'highlight2'
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faCheckCircle
    })), /*#__PURE__*/React.createElement("p", {
      className: 'highlight2'
    }, "Vielen Dank f\u00FCr deine Bewertung!"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("input", {
      type: "button",
      className: 'submit',
      value: "Schlie\u00DFen",
      onClick: reset
    }))));
  }
  return null;
}
export default Survey;